import { render, staticRenderFns } from "./MiuVipOrder.vue?vue&type=template&id=61c45356&scoped=true"
import script from "./MiuVipOrder.vue?vue&type=script&lang=js"
export * from "./MiuVipOrder.vue?vue&type=script&lang=js"
import style0 from "./MiuVipOrder.vue?vue&type=style&index=0&id=61c45356&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c45356",
  null
  
)

export default component.exports